import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/NotFound.css";

const TemporarilyUnavailable = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoHome = () => {
    const pathSegments = location.pathname.split("/");
    const lang = pathSegments[1] || "az";
    navigate(`/${lang}/`);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h2>Müvəqqəti olaraq mövcud deyil</h2>
        <p>Bu xidmət hazırda müvəqqəti olaraq əlçatan deyil. Zəhmət olmasa daha sonra yenidən cəhd edin.</p>
        <button onClick={handleGoHome} className="not-found-button">
          Ana səhifəyə qayıt
        </button>
      </div>
    </div>
  );
};

export default TemporarilyUnavailable;
